import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import CrcForeignAssetsHome from './crcAssetsHome';
import CrcAssetsAccordin from './crcAssetsAccordin';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import useStyles from './assetStyle';
import { Formik } from 'formik';

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
export default function CrcForeignAssets(apiResponse, apiData, updateApiData, props, yesorNoType, rerenderApi, rerender) {
    const [updateValuesfromChild, setUpdateValuesfromChild] = React.useState('');
    // console.log("apiResponse29", apiResponse);

    const assetChecklist = apiResponse && apiResponse.apiResponse.apiResponse[6];

    const initialValues = {
        assetradio: '',
    };

    // let assetradio7 = apiResponse.apiResponse.apiResponse[6].subQuestion[11].fields[0];
    //console.log("asset radio7" , assetradio7)
    // useEffect(() => {
    //     //console.log('CrcForeignAssets.useEffect.7th', apiResponse.apiResponse.apiResponse[6].subQuestion[11].fields[0]);
    //     setAssetRadio(apiResponse.apiResponse.apiResponse[6].subQuestion[11].fields[0]);
    // }, [props]);

    // let assetradio;
    if (assetChecklist && assetChecklist.subQuestion[11].fields.length > 0) {
        initialValues.assetradio = assetChecklist.subQuestion[11].fields[0].response;
    }

    const handleChangeParent = (prop) => {
        setUpdateValuesfromChild({ prop });
    };

    return (
        <>
            <Grid container spacing={3} className="main-container w100i">
                <Formik initialValues={initialValues} enableReinitialize>
                    {(formik) => {
                        return (
                            <>
                                <Grid item xs={12} sm={12} style={{ padding: '0 12px' }}>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-label="yes-no"
                                            id="assetradio"
                                            name="assetradio"
                                            className="radio-option ml15"
                                            value={formik.values.assetradio}
                                        >
                                            <ul className="makeStyles-inlineDisplay-111">
                                                <li>
                                                    <FormControlLabel
                                                        name="assetradio"
                                                        value="Yes"
                                                        control={<StyledRadio />}
                                                        label="Yes"
                                                        disabled
                                                    />
                                                </li>
                                                <li>
                                                    <FormControlLabel
                                                        name="assetradio"
                                                        value="No"
                                                        control={<StyledRadio />}
                                                        label="No"
                                                        disabled
                                                    />
                                                </li>
                                            </ul>
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                {formik.values.assetradio === 'Yes' ? (
                                    <Grid>
                                        <CrcForeignAssetsHome
                                            rerenderApi={apiResponse.rerenderApi}
                                            rerender={apiResponse.rerender}
                                            apiResponse={apiResponse}
                                            yesorNoType={apiResponse && apiResponse.yesorNoType}
                                            addAdditionalQue={apiResponse && apiResponse.addAdditionalQue}
                                            apiData={apiData}
                                            updateApiData={updateApiData}
                                            onChange={handleChangeParent}
                                        />
                                        <CrcAssetsAccordin
                                            rerenderApi={apiResponse.rerenderApi}
                                            rerender={apiResponse.rerender}
                                            apiResponse={apiResponse}
                                            yesorNoType={apiResponse && apiResponse.yesorNoType}
                                            addAdditionalQue={apiResponse && apiResponse.addAdditionalQue}
                                            apiData={apiData}
                                            updateApiData={updateApiData}
                                            onChange={handleChangeParent}
                                        />
                                    </Grid>
                                ) : null}
                            </>
                        );
                    }}
                </Formik>
            </Grid>
        </>
    );
}
